import { render, staticRenderFns } from "./RemoveBtn.vue?vue&type=template&id=0685c859&"
import script from "./RemoveBtn.vue?vue&type=script&lang=js&"
export * from "./RemoveBtn.vue?vue&type=script&lang=js&"
import style0 from "./RemoveBtn.vue?vue&type=style&index=0&id=0685c859&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports